import { computed, DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ShortlistService } from '@rma/public/compare-agent/private-api/da-compare-agent';
import { CompareTile } from '../domain/compare-tile';
import { toCompareTile } from '../util/compare-tile.mapper';

/**
 * Projects the shortlist into tiles; the shortlist owns resolution. `ShortlistService` is a token,
 * not a concrete class — location comparison routes substitute `LocationCompareService` for it.
 */
@Injectable()
export class CompareTrayFacade {
  private readonly destroyRef = inject(DestroyRef);
  private readonly shortlistService = inject(ShortlistService);

  private readonly shortlistAgents = this.shortlistService.resolveAgents();

  public readonly loading = this.shortlistAgents.agentsLoading;
  public readonly failed = this.shortlistAgents.agentsFailed;

  public readonly tiles = computed<CompareTile[]>(() => {
    const agencyThemes = this.shortlistAgents.agencyThemes();
    const agents = [...this.shortlistAgents.agents()];

    return agents.reverse().map((agent) => toCompareTile(agent, agent.agencyCode ? agencyThemes.get(agent.agencyCode) : undefined));
  });

  public remove(agentCode: string): void {
    this.shortlistService.remove(agentCode).pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
  }

  public clear(): void {
    this.shortlistService.clear().pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
  }
}
